import React from "react";
import { FaCheckCircle, FaSpinner, FaExclamationCircle } from "react-icons/fa";
import { renderCardIcon, trainingDataIcon } from "../common/IconLibrary";

const StatusBadge = ({ status }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'processed':
        return 'bg-green-500/50';
      case 'pending':
        return 'bg-yellow-500';
      case 'error':
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'processed':
        return <FaCheckCircle className="mr-1" />;
      case 'pending':
        return <FaSpinner className="mr-1 animate-spin" />;
      case 'error':
        return <FaExclamationCircle className="mr-1" />;
      default:
        return null;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'processed':
        return 'Uploaded';
      case 'pending':
        return 'Uploading';
      default:
        return status;
    }
  };

  return (
    <span className={`flex items-center px-2 py-1 rounded-full text-xs text-white ${getStatusColor(status)}`}>
      {getStatusIcon(status)}
      <span className="capitalize">{getStatusText(status)}</span>
    </span>
  );
};

const TrainingDataCard = ({ item, onClick }) => {
  return (
    <div className="card-glass cursor-pointer flex flex-col h-full" onClick={() => onClick(item)}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center">
          <span className="text-gray-300 mr-2">
            {renderCardIcon(trainingDataIcon, 24)}
          </span>
          <h3 className="text-xl font-semibold text-gray-100">{item.name}</h3>
        </div>
      </div>
      <div className="text-gray-300 mb-3 flex-grow">
        <p className="text-sm line-clamp-3 min-h-[3em]">{item.description || "No description provided"}</p>
      </div>
      <div className="flex flex-col space-y-2">
        <div className="flex flex-wrap">
          {item.tags && item.tags.length > 0 ? (
            item.tags.map((tag) => (
              <span
                key={tag}
                className="bg-blue-500 text-white text-xs px-2 py-1 rounded-full mr-2 mb-2"
              >
                {tag}
              </span>
            ))
          ) : (
            <span className="text-gray-400 text-sm">No tags</span>
          )}
        </div>
        <div className="flex items-center">
          <StatusBadge status={item.status} />
        </div>
      </div>
    </div>
  );
};

export default TrainingDataCard;